import { sum } from 'lodash';

const numbers = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];

export const middle = (numbers: number[], count: number) =>
  (sum(numbers) / count).toFixed(2);

export const clearArray = (array: any[]) =>
  array.map((item: any) => ({
    ...item,
    id: item.id > 1000000000000 ? null : item.id,
  }));

export function numberWithCommas(x: number) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function getQuart(m: number) {
  return Math.ceil((m + 1) / 3);
}

export const clearUnit = (unit: string | null) =>
  unit !== null ? unit.split("").filter((item: string) => numbers.includes(item)).join("") : "";